<!-- Begin page content -->
<section id="slider">
  <ngb-carousel>
    <ng-container *ngFor="let news of kazNews">
      <ng-template ngbSlide>
        <div class="wrapper" (click)="redirectNewsPage(news.id)">
          <img src="{{news.image}}" alt="Random first slide">
        </div>
        <div class="carousel-caption">
            <h3>{{news.title}}</h3>
          <p class="card-text"><small
            class="text-muted">{{news.published | date: 'dd.MM.yyyy'}}</small></p>
        </div>
      </ng-template>
    </ng-container>
    <ng-container *ngIf="!kazNews || kazNews.length == 0">
      <ng-template ngbSlide>
        <div class="wrapper">
          <img src="../../assets/img/slider.png" alt="Random first slide">
        </div>
        <div class="carousel-caption">
          <!-- <h3>Добро пожаловать на страницу </h3> -->
          <h4>9qq.org</h4>
        </div>
      </ng-template>
    </ng-container>
  </ngb-carousel>
</section>

<main class="flex-shrink-0">
  <div class="container">

    <!-- News section -->
    <section id="news" [ngClass]="{block: kazNews, none: kazNews.length === 0}">
      <div *ngIf="kazNews?.length > 0" class="news-content">
        <div class="container">
          <div class="row mt-3">
            <div class="col-lg-3">
              <span class="title">Новости Казахстана</span>
            </div>
            <div class="col">
              <div class="line"></div>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-lg-3" *ngFor="let item of kazNews">
              <div class="card mb-3" (click)="redirectNewsPage(item.id)">
                <!-- <img src="../../assets/img/55.png" class="card-img-top" alt="..."> -->
                <img src="{{item.image}}" class="card-img-top" alt="...">
                <div class="card-body">
                  <!-- <h5 class="card-title">Card title</h5> -->
                  <p class="card-text"><small
                    class="text-muted">Опубликовано {{item.published | date: 'dd.MM.yyyy'}}</small></p>
                  <p class="card-text">{{item.title}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 text-center">
              <nav aria-label="Page navigation example">
                <ul class="pagination justify-content-center">
                  <li class="page-item disabled">
                    <a class="page-link" href="#" tabindex="-1" aria-disabled="true">Пред</a>
                  </li>
                  <li class="page-item"><a class="page-link" href="#">1</a></li>
                  <li class="page-item"><a class="page-link" href="#">2</a></li>
                  <li class="page-item"><a class="page-link" href="#">3</a></li>
                  <li class="page-item">
                    <a class="page-link" href="#">След</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="worldNews" [ngClass]="{block: worldNews, none: worldNews.length === 0}">
      <div *ngIf="worldNews?.length > 0" class="news-content">
        <div class="container">
          <div class="row mt-3">
            <div class="col-lg-3">
              <span class="title">Международные новости</span>
            </div>
            <div class="col">
              <div class="worldLine"></div>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-lg-3" *ngFor="let item of worldNews">
              <div class="card mb-3" (click)="redirectNewsPage(item.id)">
                <!-- <img src="../../assets/img/55.png" class="card-img-top" alt="..."> -->
                <img src="{{item.image}}" class="card-img-top" alt="...">
                <div class="card-body">
                  <!-- <h5 class="card-title">Card title</h5> -->
                  <p class="card-text"><small
                    class="text-muted">Опубликовано {{item.published | date: 'dd.MM.yyyy'}}</small></p>
                  <p class="card-text">{{item.title}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 text-center">
              <nav aria-label="Page navigation example">
                <ul class="pagination justify-content-center">
                  <li class="page-item disabled">
                    <a class="page-link" href="#" tabindex="-1" aria-disabled="true">Пред</a>
                  </li>
                  <li class="page-item"><a class="page-link" href="#">1</a></li>
                  <li class="page-item"><a class="page-link" href="#">2</a></li>
                  <li class="page-item"><a class="page-link" href="#">3</a></li>
                  <li class="page-item">
                    <a class="page-link" href="#">След</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>

  <section #partners id="partners" [ngClass]="{paddingPartners: worldNews, paddingNoPartners: !worldNews || worldNews.length === 0}">
    <app-partners></app-partners>
  </section>
</main>
